import { Component, Input, OnChanges, OnInit, SimpleChanges, effect, input, WritableSignal, model, computed } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from 'app/core/services/toast/toast.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { ModuleIcon } from 'app/interfaces/module-icon.interface';
import { MessagesService } from 'app/layout/common/messages/messages.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit, OnChanges {

  show: any = model();
  message: any = model();
  additionalData: any;
  messageData: any;
  showToast: boolean = false;
  animation: boolean = true;
  toggler: boolean = false;
  showTimeout: any;
  hideTimeout: any;
  toastStateSignal = this._toastService.toastState;
  constructor(
    private _router: Router,
    private _utilityService: UtilityService,
    private _messagesService: MessagesService,
    private _toastService: ToastService
  ) { 

    // Use the service's signal directly in the effect
    effect(() => {
      const state = this._toastService.toastState();
      if(state?.show){
        this.show.set(state.show);
        this.message.set(state.message);
        this.showDisplayToast();
      }
    }, {allowSignalWrites: true});
  }

  ngOnInit(): void {

  }

  closeToast(event: Event): void{
    event.preventDefault();
    event.stopPropagation();
    this.showToast=false;
    this.animation=true;
  }

  onMouseEnter(): void {
    if(this.showTimeout) {clearTimeout(this.showTimeout);}
    if(this.hideTimeout) {clearTimeout(this.hideTimeout);}

  }

  onMouseLeave(): void {
    this.animation = true;
    this.showToast = false;
    setTimeout(()=>{
      this.toggler = false;
    },200);
  }

  navigateTo(module, data): void{
    if(module === 'STREAM_CHAT'){
      const additionalData = typeof data === 'string' ? JSON.parse(data) : data;
      this._router.navigateByUrl('/chats/' + additionalData.channel_type + '/' + additionalData.channel_id, {
        'state': {
          data : {
            messageId: additionalData?.message_id,
            parentId: additionalData?.parent_id,
            message: additionalData?.message
          }
        }
      });
    } else if(module === 'CHAT'){
      this._router.navigateByUrl('/chats/'+data);
    } else if(module === 'JOB'){
      this._router.navigateByUrl('/jobs/'+data+'/details');
    } else if(module === 'USER' && this._utilityService.hasModuleAccess('USER')){
      this._router.navigateByUrl('/employees/'+data+'/details');
    }
  }

  navigateToCall(data): void{
    if(data?.type === 'CALLER' && data?.additional_data?.conversation?.conversation_uid){
      this._router.navigateByUrl('/connect/conversations/'+data.additional_data.conversation.conversation_uid);
    }
  }

  openMessageTab(): void {
    this._messagesService.showMessageTab = true;
  }

  getIconClass(module: string): string {
    return ModuleIcon[module];
  }

  formatPhoneNumber(phoneNumber: string): string {
    if (!phoneNumber) return phoneNumber;
  
    // Handle numbers with country code (e.g., +91 9626720760 or (+1) 463 232 3489)
    const matchInternational = phoneNumber.match(/^(\d{1,3})(\d{10})$/);
    if (matchInternational) {
      return `(+${matchInternational[1]}) ${matchInternational[2].slice(0, 3)} ${matchInternational[2].slice(3, 6)} ${matchInternational[2].slice(6)}`;
    }
  
    // Handle numbers with 2-digit country code and 10-digit local number (e.g., +91 9626720760)
    const matchWithCountryCode = phoneNumber.match(/^\+(\d{2})(\d{10})$/);
    if (matchWithCountryCode) {
      return `+${matchWithCountryCode[1]} ${matchWithCountryCode[2].slice(0, 3)} ${matchWithCountryCode[2].slice(3, 6)} ${matchWithCountryCode[2].slice(6)}`;
    }

    // Handle domestic number with 10 digits (e.g., 9626720760)
    const matchDomestic = phoneNumber.match(/^(\d{10})$/);
    if (matchDomestic) {
      return `${matchDomestic[1].slice(0, 3)} ${matchDomestic[1].slice(3, 6)} ${matchDomestic[1].slice(6)}`;
    }
  
    return phoneNumber;
  }

  showDisplayToast(): void {
    if(this.showTimeout) {clearTimeout(this.showTimeout);}
      if(this.hideTimeout) {clearTimeout(this.hideTimeout);}
      this.showToast = true;
      this.animation = true;
      this.toggler = true;
      this.showTimeout = setTimeout(()=>{
        this.animation = false;
        this.showToast = true;
      },1000);

      this.hideTimeout = setTimeout(()=>{
        this.animation = true;
        this.showToast = false;
        setTimeout(()=>{
          this.toggler = false;
        },200);
      },6000);
      if (this.message()?.data) {
        this.messageData = this.message()?.data;
      
        if (typeof this.messageData.additional_data === 'string') {
          try {
            this.messageData.additional_data = JSON.parse(this.messageData.additional_data);
          } catch (error) {
            this.messageData.additional_data = {};
          }
        }
      
        this.additionalData = this.messageData.additional_data || {};
      }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes?.show?.currentValue){
      this.showDisplayToast();
    }
  }

}
